(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () { 
    if (window.innerWidth > 768) return;
    const carousel = document.querySelector('.unb-mobile-carousel');
    if (!carousel) return;

    const track = carousel.querySelector('.unb-track');
    let slides = Array.from(carousel.querySelectorAll('.unb-slide'));
    const dots = carousel.querySelectorAll('.unb-dot');
    const fullscreen = document.querySelector('.unb-fullscreen');
    const fullscreenTrack = document.querySelector('.unb-fullscreen-track');
    const closeBtn = document.querySelector('.unb-close');

    if (!track || slides.length < 2) return;
    if (!carousel || !fullscreen) return;

    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);

    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    slides = Array.from(carousel.querySelectorAll('.unb-slide'));

    requestAnimationFrame(() => {
      track.scrollLeft = slides[1].offsetLeft;
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        track.scrollTo({
          left: slides[i + 1].offsetLeft,
          behavior: 'smooth'
        });
      });
    });
   
    function updateDots(index) {
      dots.forEach(d => d.classList.remove('is-active'));
      if (dots[index]) dots[index].classList.add('is-active');
    }

    function getClosestSlideIndex() {
      const scrollLeft = track.scrollLeft;

      let closestIndex = 0;
      let smallestDiff = Infinity;

      slides.forEach((slide, i) => {
        const diff = Math.abs(scrollLeft - slide.offsetLeft);
        if (diff < smallestDiff) {
          smallestDiff = diff;
          closestIndex = i;
        }
      });

      return closestIndex;
    }

    function handleSnap() {
      const index = getClosestSlideIndex();

      // If fake first (clone of last)
      if (index === 0) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = slides[slides.length - 2].offsetLeft;
        track.style.scrollBehavior = 'smooth';
        updateDots(dots.length - 1);
        return;
      }

      // If fake last (clone of first)
      if (index === slides.length - 1) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = slides[1].offsetLeft;
        track.style.scrollBehavior = 'smooth';
        updateDots(0);
        return;
      }

      updateDots(index - 1);
    }

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', handleSnap);
    } else {
      let timeout;
      track.addEventListener('scroll', () => {
        clearTimeout(timeout);
        timeout = setTimeout(handleSnap, 100);
      });
    }

    slides.forEach((slide, index) => {
      slide.addEventListener('click', function () {
        fullscreen.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Clear previous
        fullscreenTrack.innerHTML = '';

        // Clone slides into fullscreen
        slides.forEach((s) => {
          fullscreenTrack.appendChild(s.cloneNode(true));
        });

        // Scroll to clicked image
        requestAnimationFrame(() => {
          const target = fullscreenTrack.children[index];
          fullscreenTrack.scrollLeft = target.offsetLeft;
        });
      });
    });

    // Close
    closeBtn.addEventListener('click', function () {
      fullscreen.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
